<template>
  <p class="records mb-0">
    <span class="tab-d-none">Showing</span>
    <span class="record-num font-weight-bold">{{
      start 
    }}</span> to 
    <span class="record-num font-weight-bold">{{ endShowingValue }}</span
    >&nbsp; out of &nbsp;
    <span class="record-num font-weight-bold">{{ totalRecord }}</span>
    records
  </p>
</template>

<script>
export default {
  name: "RecordCount",
  props: {
    endShowingValue: Number,
    totalRecord: Number,
    start: Number,
    perPage: Number,
  },
};
</script>

<style scoped>
.records {
  display: flex;
  align-items: center;
  font-size: 15px;
  color: #4b5068;
}
.record-num {
  padding: 0 5px;
  /* color:#444444; */
}
</style>
